import { combineReducers } from "redux";

import { IStoreState } from "./initialStoreState";
import { messageReducer } from "./messages/messagesReducer";

import { commonReducer } from "./common/commonReducer";

import { UserProfileReducer } from "./UserProfileList/userProfileReducer";

import { activityReducer } from "./activity/activityReducer";
import { customizerReducer } from "./customizer/customizerReducer";
import { feeStructureReducer } from "./feeStructure/feeStructures.reducer";
import { leadsReducer } from "./leads/leadsReducer";
import { opportunitesReducer } from "./opportunites/opportunitesReducer";
import { securityReducer } from "./security/securityReducer";
import { studentReducer } from "./student/studentReducer";
import { templateReducer } from "./templates/templateReducer";
import { organizationReducer } from "./organization/organization.reducer";
import { report } from "process";
import { reportsReducer } from "./reports/reportsReducers";
import { studentReportReducer } from "./StudentReport/StudentReportReducers";
import { receiptReportReducer } from "./receiptReport/receiptReducers";
import { courseandbatchReportReducer } from "./courseandbatchReport/reducers";
import { totalRecordReducer } from "./TotalRecords/reducers";
import { optionalFeeReducer } from "./optionalFee/optionalReducers";
import { paymentTypeReducer } from "./PaymentType/paymentReducer";

const appReducer = combineReducers({
	customizerReducer: customizerReducer,
	student: studentReducer,
	message: messageReducer,
	acitivty: activityReducer,
	security: securityReducer,

	templates: templateReducer,

	userprofile: UserProfileReducer,
	common: commonReducer,

	opportunites: opportunitesReducer,
	leads: leadsReducer,
	feeStructure: feeStructureReducer,
	masterOrganization:organizationReducer,
	reports:reportsReducer,
	studentReport:studentReportReducer,
	recieptReport:receiptReportReducer,
	courseandbatch:courseandbatchReportReducer,
	TotalRecords:totalRecordReducer,
	optionalFee:optionalFeeReducer,
	paymentType:paymentTypeReducer,
});

export const rootReducer = (state: IStoreState | undefined, action: any) => {
	if (action.type === "USER_LOGOUT") {
		return appReducer(undefined, action);
	}
	return appReducer(state, action);
};
